import { createFileRoute, Link } from '@tanstack/react-router'
import { contentWrapper } from '../../../../styles/contentWrapper'
import { titleWrapper, pageTitle, sectionWrapper, sectionTitle } from '../../../../styles/sectionStyles'
import ArrowBack from '~icons/material-symbols/arrow-back.svg'
import { css } from '../../../../../styled-system/css'
import { Provider } from 'jotai'
import { ApplyChanges } from './-components/apply-changes'
import { CsvErrorViewer } from './-components/error-viewer'
import { Instructions } from './-components/instructions'
import { Loader } from './-components/loader'
import { TemplateDownloader } from './-components/template-downloader'

export const Route = createFileRoute('/admin/companies/bulkCreateStoreAccounts/')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Provider>
      <div className={contentWrapper()}>
        <div className={titleWrapper()}>
          <h1 className={pageTitle()}>
            <Link to='/admin/companies'>
              <ArrowBack />
            </Link>
            店舗アカウント一括登録
          </h1>
        </div>
        <div className={css({
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
        })}>
          <div className={sectionWrapper()}>
            <div className={sectionTitle()}>テンプレートをダウンロード</div>
            <div className={css({
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
            })}>
              <p>CSVファイルのテンプレートをダウンロードします。</p>
              <TemplateDownloader />
            </div>
          </div>
          <div className={sectionWrapper()}>
            <div className={sectionTitle()}>操作方法</div>
            <Instructions />
          </div>
          <div className={sectionWrapper()}>
            <div className={sectionTitle()}>データを読み込み</div>
            <Loader />
            <CsvErrorViewer />
          </div>
          <div className={sectionWrapper()}>
            <div className={sectionTitle()}>一括登録</div>
            <ApplyChanges />
          </div>
        </div>
      </div>
    </Provider>
  )
}
